import angular from 'angular';

angular.module('cloudX').directive('cxSalutation', [
  'optionsSvc',
  function(optionsSvc) {
    return {
      restrict: 'E',
      template:
        '<select ng-model="salutation" ng-options="(salutation | translateList:\'salutation\') for salutation in salutations" ' +
        'class="form-control"> <option value="" ng-show="!salutation && salutation!==0 || !required">- {{\'Choose\'|translate}} -</option> </select>',
      scope: {
        salutation: '=data',
        required: '@',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.salutations = optionsSvc.getOptions('salutation');
        },
      ],
    };
  },
]);
